import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-[#0F0F0F] text-gray-500 py-8 px-4 sm:px-6" data-id="element-1">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm" data-id="element-2">
          <p data-id="element-3">
            © {new Date().getFullYear()} Meal Prep Turbo. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-4">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-[#E8652D] transition-colors underline underline-offset-2" data-id="element-5">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-[#E8652D] transition-colors underline underline-offset-2" data-id="element-6">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-7">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-8">
            <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 10,
          scale: 0.97
        }} transition={{
          duration: 0.25
        }} onClick={e => e.stopPropagation()} className="bg-[#FAFAF7] text-[#1A1A1A] rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" data-id="element-9">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 shrink-0" data-id="element-10">
                <h2 className="text-lg font-bold" data-id="element-11">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-[#111111] transition-colors p-1 rounded-lg hover:bg-gray-100" data-id="element-12">
                  <XIcon className="h-5 w-5" data-id="element-13" />
                </button>
              </div>

              {/* Content */}
              <div className="overflow-y-auto px-6 py-6 text-sm leading-relaxed text-gray-600 space-y-4" data-id="element-14">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-15" /> : <TermsContent data-id="element-16" />}
              </div>

              {/* Footer */}
              <div className="px-6 py-4 border-t border-gray-200 shrink-0" data-id="element-17">
                <button onClick={() => setActiveModal(null)} className="w-full sm:w-auto px-6 py-2.5 bg-[#111111] text-white rounded-full text-sm font-semibold hover:bg-[#222222] transition-colors" data-id="element-18">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-gray-400" data-id="element-19">
        Última actualización: febrero 2026
      </p>

      <h3 className="font-bold text-[#111111] text-base" data-id="element-20">
        1. Información que recopilamos
      </h3>
      <p data-id="element-21">
        Al adquirir Meal Prep Turbo, recopilamos únicamente la información
        necesaria para procesar tu compra: nombre, dirección de correo
        electrónico y datos de pago. No almacenamos información de tarjetas de
        crédito directamente; los pagos son procesados por plataformas de pago
        seguras de terceros.
      </p>

      <h3 className="font-bold text-[#111111] text-base" data-id="element-22">
        2. Uso de la información
      </h3>
      <p data-id="element-23">Utilizamos tu información para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-24">
        <li data-id="element-25">Procesar y entregar tu compra (envío del PDF).</li>
        <li data-id="element-26">
          Enviarte actualizaciones relacionadas con el producto, si las hubiera.
        </li>
        <li data-id="element-27">Responder a consultas de soporte.</li>
      </ul>
      <p data-id="element-28">
        No vendemos, alquilamos ni compartimos tu información personal con
        terceros con fines de marketing.
      </p>

      <h3 className="font-bold text-[#111111] text-base" data-id="element-29">3. Cookies</h3>
      <p data-id="element-30">
        Nuestro sitio puede utilizar cookies básicas para mejorar la experiencia
        de navegación y analizar el tráfico de forma anónima. No utilizamos
        cookies para rastreo publicitario.
      </p>

      <h3 className="font-bold text-[#111111] text-base" data-id="element-31">
        4. Protección de datos
      </h3>
      <p data-id="element-32">
        Implementamos medidas de seguridad razonables para proteger tu
        información personal contra acceso no autorizado, alteración o
        destrucción.
      </p>

      <h3 className="font-bold text-[#111111] text-base" data-id="element-33">5. Tus derechos</h3>
      <p data-id="element-34">
        Tienes derecho a acceder, rectificar o eliminar tus datos personales en
        cualquier momento. Para ejercer estos derechos, puedes contactarnos a
        través de los canales indicados en tu correo de confirmación de compra.
      </p>

      <h3 className="font-bold text-[#111111] text-base" data-id="element-35">
        6. Cambios en esta política
      </h3>
      <p data-id="element-36">
        Nos reservamos el derecho de actualizar esta política en cualquier
        momento. Los cambios serán publicados en esta misma página con la fecha
        de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-gray-400" data-id="element-37">
        Última actualización: febrero 2026
      </p>

      <h3 className="font-bold text-[#111111] text-base" data-id="element-38">
        1. Producto digital
      </h3>
      <p data-id="element-39">
        Meal Prep Turbo es un producto digital en formato PDF. Al completar la
        compra, recibirás acceso inmediato al archivo descargable. Este producto
        es para uso personal y no puede ser redistribuido, revendido ni
        compartido públicamente.
      </p>

      <h3 className="font-bold text-[#111111] text-base" data-id="element-40">2. Precio y pago</h3>
      <p data-id="element-41">
        El precio del producto es de $6.39 USD (pago único). No hay
        suscripciones, cargos recurrentes ni costos ocultos. El pago se procesa
        a través de plataformas seguras de terceros.
      </p>

      <h3 className="font-bold text-[#111111] text-base" data-id="element-42">
        3. Propiedad intelectual
      </h3>
      <p data-id="element-43">
        Todo el contenido de Meal Prep Turbo (textos, diseños, plantillas,
        sistema y metodología) está protegido por derechos de autor. Queda
        prohibida su reproducción, distribución o modificación sin autorización
        expresa.
      </p>

      <h3 className="font-bold text-[#111111] text-base" data-id="element-44">
        4. Descargo de responsabilidad
      </h3>
      <p data-id="element-45">
        Meal Prep Turbo es una guía educativa de organización alimentaria. No
        constituye asesoramiento médico, nutricional clínico ni tratamiento para
        condiciones de salud. Consulta a un profesional de salud antes de
        realizar cambios significativos en tu alimentación, especialmente si
        tienes condiciones médicas preexistentes.
      </p>

      <h3 className="font-bold text-[#111111] text-base" data-id="element-46">5. Resultados</h3>
      <p data-id="element-47">
        Los resultados pueden variar según cada persona. No garantizamos
        resultados específicos de pérdida de peso o grasa. El éxito depende de
        la aplicación individual del sistema y de factores personales como
        actividad física, metabolismo y adherencia.
      </p>

      <h3 className="font-bold text-[#111111] text-base" data-id="element-48">6. Modificaciones</h3>
      <p data-id="element-49">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor desde su publicación en
        esta página.
      </p>
    </>;
}